import { z } from "zod/v4"
import { JobStatus } from "./push-broker"
import { CreatedAt, UpdatedAt } from "./system"

export enum OGPStatus {
  WIP = "in_progress",
  READY = "ready",
  ERROR = "error",
}

export const OGPImage = z.object({
  url: z.string().describe("OGP に紐づいた画像の URL です。"),
  original_url: z.string().optional(),
})

export type OGPImage = z.infer<typeof OGPImage>

// https://ogp.me
export const OGPEntry = z.object({
  original_url: z.string().describe("OGP の展開の対象となった、元の URL です。"),
  url: z.string().optional().describe("og:url の値が入ります。"),
  type: z.string().optional().describe("`og:type` の値が入ります。"),
  title: z.string().optional().describe("`og:title` の値が入ります。"),
  description: z.string().optional().describe("`og:description` の値が入ります。"),
  images: z.array(OGPImage).describe("`og:image:*` 由来の画像リストです。")
})

export type OGPEntry = z.infer<typeof OGPEntry>

export const OGP = z.object({
  status: z.enum(OGPStatus).describe(
    `OGP の展開状態を表します。
    |
    |各定数の意味は以下の通りです。
    |
    | - \`in_progress\`
    |    - 展開の処理を実行している状態です
    | - \`ready\`
    |    - 展開に成功し \`entries\` に結果が設定された状態です
    | - \`error\`
    |    - 展開に失敗したことを示します
    `.replace(/^\s*\|?/mg, "")
  ),
  entries: z.array(OGPEntry).describe("テキスト中のリンクから展開された OGP のリストです。"),
})

export type OGP = z.infer<typeof OGP>

export const OGPJobDoc = z.object({
  status: z.nativeEnum(JobStatus),
  urls: z.string().array(),
  dest_doc_path: z.string(),
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type OGPJobDoc = z.infer<typeof OGPJobDoc>
